'use client';

import { c as _c } from "react/compiler-runtime";
import { TextButton, Typography } from '@/shared/ui/atoms';
import { useSearchUiPersistStore } from '@/features/search/model/ui/store';
import { IconButton, RecentIcon } from '@/shared/ui/atoms';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
const RecentSearchKeyword = () => {
  const $ = _c(23);
  const t = useTranslations();
  const {
    recentClear,
    recentSearchKeywordList,
    setRecentSearchKeywordList
  } = useSearchUiPersistStore();
  let t0;
  if ($[0] !== recentClear) {
    t0 = () => {
      recentClear();
    };
    $[0] = recentClear;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClearRecentSearchKeyword = t0;
  let t1;
  if ($[2] !== recentSearchKeywordList || $[3] !== setRecentSearchKeywordList) {
    t1 = keyword => {
      const newRecentSearchKeywordList = recentSearchKeywordList.filter(item => item !== keyword);
      setRecentSearchKeywordList(newRecentSearchKeywordList);
    };
    $[2] = recentSearchKeywordList;
    $[3] = setRecentSearchKeywordList;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleDeleteRecentSearchKeyword = t1;
  let t2;
  if ($[5] !== t) {
    t2 = t("recentSearch.title");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <Typography size={16} lineHeight={24} className="text-gray-900 font-bold">{t2}</Typography>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== handleClearRecentSearchKeyword || $[10] !== recentSearchKeywordList.length || $[11] !== t) {
    t4 = recentSearchKeywordList.length > 0 && <TextButton text={t("recentSearch.clearAll")} size={14} className="text-gray-500" onClick={handleClearRecentSearchKeyword} />;
    $[9] = handleClearRecentSearchKeyword;
    $[10] = recentSearchKeywordList.length;
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div className="flex items-center justify-between mb-4">{t3}{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== handleDeleteRecentSearchKeyword || $[17] !== recentSearchKeywordList || $[18] !== t) {
    t6 = <div className="flex flex-col gap-2 min-h-[140px]">{recentSearchKeywordList.length > 0 ? <><div className="flex flex-col gap-5">{recentSearchKeywordList.map((item_0, index) => <div key={`recent-search-keyword-${index}`} className="flex items-center gap-2 w-full justify-between"><div className="flex items-center gap-2"><div className="p-1 bg-gray-100 rounded-lg"><RecentIcon size={20} className="text-gray-500" /></div><Link href={`/search/result?query=${item_0}`} className="text-gray-800 text-[15px]" onMouseDown={_temp}>{item_0}</Link></div><IconButton src="/icons/close.svg" alt="close" width={16} height={16} onClick={() => handleDeleteRecentSearchKeyword(item_0)} /></div>)}</div></> : <Typography size={15} lineHeight={22} className="text-gray-800 text-center my-[58px]">{t("recentSearch.noRecentSearch")}</Typography>}</div>;
    $[16] = handleDeleteRecentSearchKeyword;
    $[17] = recentSearchKeywordList;
    $[18] = t;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t5 || $[21] !== t6) {
    t7 = <div className="w-full pt-6 px-4">{t5}{t6}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default RecentSearchKeyword;
function _temp(e) {
  return e.preventDefault();
}